import React from 'react';
import { VsPageLayout } from '../components/VsPageLayout';
export function VsZapier() {
  return <VsPageLayout competitorName="Zapier" competitorDescription="Zapier connects apps and automates workflows between them." seoTitle="MindStream.ing vs Zapier — Why MISTR Beats Automation-Only Tools" comparisonRows={[{
    feature: 'AI-powered (understands context)',
    mistr: '✅',
    competitor: '❌ (rule-based)'
  }, {
    feature: 'Voice input (just talk)',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'No setup required',
    mistr: '✅',
    competitor: '❌ (requires building zaps)'
  }, {
    feature: 'Project management built-in',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'CRM management',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Content creation',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'PPC management',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Email monitoring & response',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Learns your business',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Done-for-you setup',
    mistr: '✅',
    competitor: '❌ (DIY)'
  }]} whyMistrWins={[{
    title: 'AI That Understands',
    desc: 'MR understands context, Zapier only follows rigid rules.'
  }, {
    title: 'Zero Learning Curve',
    desc: 'No complex zap building. Just talk and MR executes.'
  }, {
    title: 'Manages Outcomes',
    desc: 'MR focuses on the final result, not just the trigger.'
  }, {
    title: 'Replaces the Team',
    desc: 'MR replaces roles, Zapier just replaces the glue between apps.'
  }]} cantDoList={['Understand what you mean (it only follows rules)', 'Answer your phone or respond to emails intelligently', 'Create content in your brand voice', 'Manage projects or follow up on tasks', 'Replace any employee role']} priceComparison={{
    competitorPrice: '$49/mo',
    competitorDesc: 'Zapier Pro (750 tasks)',
    mistrPrice: '$997/mo',
    mistrDesc: 'MR Pro (unlimited — runs your entire business)',
    note: 'Most businesses need Zapier Team at $399/mo+ and still need to build every automation manually.'
  }} data-id="element-2899" />;
}